module.exports = __webpack_public_path__ + "img/logo.431ed40d.png";